import React from 'react';
import '../template-file-css/document-file-template.css';


export const HMTP_IntakeChecklist = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='HMTP_IntakeChecklist' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h3>INTAKE Checklist</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>REQUIRED DOCUMENTATION FOR ADMISSION PACKAGE</span> </td>
                        <td className='w-250'> <span className='eleHeader'>VERIFIED BY INTAKE STAFF</span>
                            <span className='small'>(signature that completed)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_1' name='cbRequiredDocumentationForAdmissionPackage_1' className='add-only' value='IntakeReferralScreeningForm' /> Intake/Referral Screening Form
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_2' name='cbRequiredDocumentationForAdmissionPackage_2' className='add-only' value='ClientHandbookAcknowledgementForm' /> Client Handbook Acknowledgement Form
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_3' name='cbRequiredDocumentationForAdmissionPackage_3' className='add-only' value='ConsentForTreatment' /> Consent For Treatment
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_4' name='cbRequiredDocumentationForAdmissionPackage_4' className='add-only' value='HMTPInformedConsent' /> HMTP Informed Consent
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_5' name='cbRequiredDocumentationForAdmissionPackage_5' className='add-only' value='CostSharingFeeAgreement' /> Cost Sharing Fee Agreement
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_6' name='cbRequiredDocumentationForAdmissionPackage_6' className='add-only' value='ConfidentialityStatement' /> Confidentiality Statement
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_7' name='cbRequiredDocumentationForAdmissionPackage_7' className='add-only' value='TransportationStatement' /> Transportation Statement
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_8' name='cbRequiredDocumentationForAdmissionPackage_8' className='add-only' value='CFRPartSUDClientsOnly' /> 42 C.F.R. Part 2 (SUD Clients Only)
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_9' name='cbRequiredDocumentationForAdmissionPackage_9' className='add-only' value='AuthorizationToDiscloseOnlySignifNeeded' /> Authorization to Disclose **Only sign if needed**
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_10' name='cbRequiredDocumentationForAdmissionPackage_10' className='add-only' value='ClientsRightsGrievancePolicy' /> Client's Rights/Grievance Policy
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_11' name='cbRequiredDocumentationForAdmissionPackage_11' className='add-only' value='Provider Service Overview' /> Provider Service Overview
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbRequiredDocumentationForAdmissionPackage_12' name='cbRequiredDocumentationForAdmissionPackage_12' className='add-only' value='MultipleRelationshipsForm' /> Multiple Relationships Form
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Personal Documentation </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbPersonalDocumentation_1' name='cbPersonalDocumentation_1' className='add-only' value='PhotoID' /> Photo ID
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbPersonalDocumentation_2' name='cbPersonalDocumentation_2' className='add-only' value='InsuranceCard' /> Insurance Card
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbPersonalDocumentation_3' name='cbPersonalDocumentation_3' className='add-only' value='PNMInsuranceVerification' /> PNM Insurance Verification
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbPersonalDocumentation_4' name='cbPersonalDocumentation_4' className='add-only' value='VotersRegistration' /> Voters Registration
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Intake-Assessments </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbIntakeAssessments_1' name='cbIntakeAssessments_1' className='add-only' value='IntraAgencyReferralForm' /> Intra-Agency Referral Form
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbIntakeAssessments_2' name='cbIntakeAssessments_2' className='add-only' value='IndividualTreatmentPlan' /> Individual Treatment Plan
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbIntakeAssessments_3' name='cbIntakeAssessments_3' className='add-only' value='ClientResourceAssessmentTool' /> Client Resource Assessment Tool
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbIntakeAssessments_4' name='cbIntakeAssessments_4' className='add-only' value='AssessmentAssessmentUpdate' /> Assessment/Assessment Update
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbIntakeAssessments_5' name='cbIntakeAssessments_5' className='add-only' value='ASAMLevelOfCareSUDOnly' /> ASAM Level of Care (SUD Only)
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Discharge/Termination</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Verified by Staff (signature)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbDischargeTermination_1' name='cbDischargeTermination_1' className='add-only' value='DischargeTerminationForm' /> Discharge/Termination Form
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbDischargeTermination_2' name='cbDischargeTermination_2' className='add-only' value='ClientResourceAssessmentTool' /> Client Resource Assessment Tool
                        </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Audit of Documentation</h3>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Print Name: </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature: </td>
                        <td className='small w-375'> Date: </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Intake/Referral Screening Form</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>HMTP Staff Name:</span></td>
                        <td className='w-150'><span className='eleHeader'>Time of Call:</span></td>
                        <td className='w-150'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtHmtpStaffName' name='txtHmtpStaffName' className='add-only' />
                        </td>
                        <td className='w-150'><input type='time' id='txtTimeCall' name='txtTimeCall' className='add-only' />
                        </td>
                        <td className='w-150'><input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Urgency (select one):</span></td>
                        <td className='w-250'><span className='eleHeader'>Client ID:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUrgencySelectOne_Routine' name='rbUrgencySelectOne' className='add-only' value='Routine' /> Routine &nbsp;
                            <input type='radio' id='rbUrgencySelectOne_Urgent' name='rbUrgencySelectOne' className='add-only' value='Urgent' /> Urgent &nbsp;
                            <input type='radio' id='rbUrgencySelectOne_Emergency' name='rbUrgencySelectOne' className='add-only' value='Emergency' /> Emergency
                        </td>
                        <td className='w-250'><input type='text' id='txtClientID' name='txtClientID' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAdolescentAgesGuess_Adult' name='rbAdolescentAgesGuess' className='add-only' value='Adult' /> Adult &nbsp;
                            <input type='radio' id='rbAdolescentAgesGuess_ChildAdolescent' name='rbAdolescentAgesGuess' className='add-only' value='ChildAdolescent' /> Child/Adolescent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Referral Source Name/Agency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtReferralSourceNameAgency' name='txtReferralSourceNameAgency' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-150'><span className='eleHeader'>D.O.B.</span></td>
                        <td className='w-300'> <span className='eleHeader'>Social Security Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtSocialSecurityNumber' name='txtSocialSecurityNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Email:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtEmail' name='txtEmail' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZip' name='txtZip' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Phone Number: Home:</span> </td>
                        <td className='w-300'><span className='eleHeader'>Cell:</span></td>
                        <td className='w-150'> <span className='eleHeader'>Gender:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtPhoneNumberHome' name='txtPhoneNumberHome' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhoneNumberCell' name='txtPhoneNumberCell' className='add-only' /> </td>
                        <td className='w-150'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Race & Ethinicity:</span></td>
                        <td className='w-75'><span className='eleHeader'>Age:</span></td>
                        <td className='w-225'><span className='eleHeader'>Language:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtRaceEthinicity' name='txtRaceEthinicity' className='add-only' /> </td>
                        <td className='w-75'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                        <td className='w-225'> <input type='text' id='txtLanguage' name='txtLanguage' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Insurance Type:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Medicaid Group Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtInsuranceType' name='txtInsuranceType' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidGroupNumber' name='txtMedicaidGroupNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Insurance Verification from Billers?</span> </td>
                        <td className='w-225'> <span className='eleHeader'>Insurance Valid:</span> </td>
                        <td className='w-225'> <span className='eleHeader'>Self Pay:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='radio' id='rbInsuranceVerificationFromBillers_Yes' name='rbInsuranceVerificationFromBillers' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInsuranceVerificationFromBillers_No' name='rbInsuranceVerificationFromBillers' className='add-only' value='No' /> No
                        </td>
                        <td className='w-225'>
                            <input type='radio' id='rbInsuranceValid_Yes' name='rbInsuranceValid' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInsuranceValid_No' name='rbInsuranceValid' className='add-only' value='No' /> No
                        </td>
                        <td className='w-225'>
                            <input type='radio' id='rbSelfPay_Yes' name='rbSelfPay' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSelfPay_No' name='rbSelfPay' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Minor Clients Only: Parent and/or Legal Guardian Name/Address/City/State/Zip Code/Phone Number:</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Name/Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtNameRelationshipMinorClients' name='txtNameRelationshipMinorClients' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address/City/State/Zip Code</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddressCityStateZipCodeMinorClients' name='txtAddressCityStateZipCodeMinorClients' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Phone Number: Home:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Cell:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPhoneNumberHomeMinorClients' name='txtPhoneNumberHomeMinorClients' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneNumberCellMinorClients' name='txtPhoneNumberCellMinorClients' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Email:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtEmailMinorClients' name='txtEmailMinorClients' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Emergency Contact Information Name & Relationship/Address/City/State/Zip Code/Phone Number: </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Name/Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtNameRelationshipEnergencyInformation' name='txtNameRelationshipEnergencyInformation' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address/City/State/Zip Code</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddressCityStateZipCodeEnergencyInformation' name='txtAddressCityStateZipCodeEnergencyInformation' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Phone Number: Home:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Cell:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPhoneNumberHomeEnergencyInformation' name='txtPhoneNumberHomeEnergencyInformation' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneNumberCellEnergencyInformation' name='txtPhoneNumberCellEnergencyInformation' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Reason for Referral:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtReasonForReferralClients' name='txtReasonForReferralClients' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services Referred to: Check below:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_1' name='cbServicesReferredTo_1' className='add-only' value='AdultServices' /> Adult Services
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_2' name='cbServicesReferredTo_2' className='add-only' value='ChildrenAdolescentServices' /> Children/Adolescent Services
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_3' name='cbServicesReferredTo_3' className='add-only' value='IndividualCounseling' /> Individual Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_4' name='cbServicesReferredTo_4' className='add-only' value='MHDayTreatment' /> MH Day Treatment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_5' name='cbServicesReferredTo_5' className='add-only' value='TBSCPSTServices' /> TBS/CPST Services
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_6' name='cbServicesReferredTo_6' className='add-only' value='MedicalServices' /> Medical Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_10' name='cbServicesReferredTo_10' className='add-only' value='IOP' /> IOP
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_11' name='cbServicesReferredTo_11' className='add-only' value='non-IOP' /> non-IOP
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_12' name='cbServicesReferredTo_12' className='add-only' value='Aftercare' /> Aftercare
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_7' name='cbServicesReferredTo_7' className='add-only' value='CrisisIntervention' /> Crisis Intervention
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_13' name='cbServicesReferredTo_13' className='add-only' value='FamilyCounseling' /> Family Counseling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_9' name='cbServicesReferredTo_9' className='add-only' value='CPST' /> CPST
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServicesReferredTo_15' name='cbServicesReferredTo_15' className='add-only' value='GroupTherapy' /> Group Therapy
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbServicesReferredTo_14' name='cbServicesReferredTo_14' className='add-only' value='DiagnosticAssessmentSUDOnly' /> Diagnostic Assessment SUD Only
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServicesReferredTo_8' name='cbServicesReferredTo_8' className='add-only' value='DiagnosticAssessmentMHSUD' /> Diagnostic Assessment (MH & SUD)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Office Use Only:</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Diagnostic Scheduled: Name of Clinician:</span></td>
                        <td className='w-300'><span className='eleHeader'>Date & Time of Assessment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtDiagnosticScheduleNameClinician' name='txtDiagnosticScheduleNameClinician' className='add-only' /> </td>
                        <td className='w-150'><input type='time' id='txtTimeAssessment' name='txtTimeAssessment' className='add-only' />
                        </td>
                        <td className='w-150'><input type='date' id='txtDateAssessment' name='txtDateAssessment' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>Client Acknowledgement Form</u></h3>
                </p>
                <p className='w-750'>
                    I have been informed about Client's Rights and the Grievance Procedure/Appeal Process.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been informed about confidentiality policies/HIPPA/42 C.F.R. part 2.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Client Handbook has been given and Program Rules have been provided/reviewed.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been Informed about the diagnostic assessment, how my Treatment Plan will be developed, how I am expected to participate in the development of the plan and the achievement of my goals, and the expected course of my treatment
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been asked if I give permission to obtain or provide my confidential health information to any other individual or service provider and have signed this form (if applicable).
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have signed document with description and explanation of financial obligations, fees, and any financial arrangements for services performed by Here's My Turning Point (HMTP).
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I understand the client HIPPA agreement & the Consent for Treatment.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been given a tour of the facility Including emergency exits, fire extinguishers, first aid kits, emergency exits, and bathrooms.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been made aware of the health and safety policies regarding use of tobacco products, restraint/seclusion, weapons, legal and illegal drugs, and prescription medications and what's prohibited by Here's My Turning Point (HMTP).
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I understand the different ways I can provide input into my services and provide feedback.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have met with the person responsible for my service and management of my case.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I understand information about discharge planning, service, and program expectations along with the termination process/withdrawal from my treatment.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I have been informed about my rights if staff shall identify a potential risk to my well-being.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Initials </td>
                        <td className='small w-375'> Parent and/or Legal Guardian Initials </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent and/or Legal Guardian Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>HMTP Staff Signature & Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>PATIENT CONSENT FOR TREATMENT AGREEMENT</u></h3>
                </p>
                <p className='w-750'>
                    {`I (we) hereby consent to Here's My Turning Point, LLC (HMTP) to provide treatment for me (us) and/or my minor child on an outpatient basis. This may include, but is not limited to emergency care, psychosocial assessment, psychiatric assessment, counseling, medication administration, telehealth, crisis, and any other mental services provided as part of my treatment. The risks and benefits of treatment have been explained to me (us). I (we) understand that clinical records may be reviewed by a Quality Assurance Committee and/or in clinical supervision to ensure quality treatment for my (our) family. Information necessary to carry out treatment, payment and healthcare operations will be submitted to appropriate organizations for accreditation, certification, and authorizations (Here's My Turning Point`}
                </p>
                <p className='w-750'>
                    {`LLC (HMTP)) Patient's Rights and Responsibilities, ii) Patient Grievance Procedures and iii) Notice of Privacy Practices have been explained to me and I have received my own copy. I (we) consent shall also include a personal history, which will assist the staff in developing a treatment plan and in providing treatment. If appropriate, I further give my consent to undergo a random urine screening to determine if alcohol or drugs have been used by me. I give my consent for individual, couple, family and/or group therapy as deemed necessary by the HMTP staff`}
                </p>
                <p className='w-750'>
                    <ol>{`I give my consent for the staff of HMTP including, but not limited to my psychiatrist, nurses, clinicians, interns, or staff, to share information within the agency about my treatment. If Here's My Turning Point, LLC (HMTP) Privacy Practices should change, I (we) will be notified of the change. The new notice of Privacy Practices will also be posted. I authorize for transportation if needed as a part of the services provided by HMTP. I understand that there may be occasions when I (we) client will be transported to participate in appointments or educational, cultural, therapeutic, and/or recreational activities. I authorize HMTP employees to provide transportation for I (we) named client and understand that HMTP is exempt from any liability and/or damages.`}
                    </ol>
                </p>
                <p className='w-750'>
                    {`By signing below, I voluntarily consent to evaluation and treatment at Here's My Turning Point, LLC, (HMTP) If signing on behalf of a client I(we)attest that I have the legal authority to sign for the named individual`}
                </p>
                <p className='w-750'>
                    <span className='small'>{`(NOTE: To provide treatment to minors,`}<b>Here's My Turning Point, LLC (HMTP)</b>{`is required to obtain consent from the minor parent, legal guardian, or custodian. By signing below, you are attesting that you are legally responsible for the minor.)`}</span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`You have the right to refuse treatment. If you refuse treatment,`} <b>Here's My Turning Point, LLC(HMTP)</b> {`staff will, with your approval, help in developing alternative approaches to ensure you and/or your minor child receive the recommended/needed services. If you refuse treatment, please sign below.`}
                </p>
                <p className='w-750'>
                    <span className='small'>{`I (we) hereby refuse my (our) consent for`}<b>Here's My Turning Point, LLC (HMTP)</b>{`to provide treatment to me (us) and/or for my minor child. The effects of this decision along with potential consequences have been explained to me and efforts have been made to offer help in developing alternative treatment approaches.`}</span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`You have the right to withdraw consent for treatment at any time. If you choose to withdraw consent, Here's My Turning Point, LLC(HMTP) staff will explain any implications or potential consequences of withdrawing treatment. If you have chosen to withdraw consent for treatment, please sign below`}
                </p>
                <p className='w-750'>
                    <span className='small'>{`I (we) hereby withdraw my (our) consent for`}<b>Here's My Turning Point, LLC (HMTP)</b>{`to provide treatment for me (us) and/or for my minor child. The efforts of this decision and potential consequences for withdrawing consent have been explained to me and efforts have been made to offer help in developing alternative treatment approaches.`}</span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>HMTP Informed Consent</u></h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Name of Client/Patient</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtNameOfClientPatient' name='txtNameOfClientPatient' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b><u>Electron Transmission of Information:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I, the undersigned, a citizen of Ohio on my behalf, agree to participate in technulogy-based therapy and other healthcare-related information exchanges with HMTP, a behavioral health care facility. This means that I authorize information related to my medical and behavioral health to be electronically transmitted in the form of images and data through an interactive video connection to and from the above-name practitioner, other persons involved in my health care.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Mobile Application:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`It may also mean that my private health information may be transmitted from my practitioner's mobile device to my own or from my device to that of my practitioner via an application “(abbreviated as “app”).`} </li>
                        <li> {`I understand that a variety of alternative methods of behavioral health care may be available to me, and that I may choose one or more of these at any time. My behavioral health care provider has explained the alternative to my satisfaction. `} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Equipment:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I represent that I am using my own equipment to communicate and not equipment owned by another and specifically not using my employer's computer can be considered by the courts to belong to my employer and my privacy may thus be compromised.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Identification:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that I will be informed of the identities of all parties present during the therapy or who has access to my personal health information and of the purpose for such individuals to have such access.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Telebehavioral Health Process:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`My health care practitioner has explained how the Telebehavioral Health therapy is performed and how it will be used for my treatment. My behavioral practitioner has also explained how the therapy(s) will differ from in-person services, including but not limited to emotional reactions that may be generated by the technology.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Additional Services:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that it is my duty to inform my practitioner of electronic interactions regarding my care that I may have with other health care providers.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Electronic Presence:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`In brief, I understand that my practitioner will not be physically in my presence. Instead, we will see and hear each other electronically, or that other information such as information I enter into an “app” will be transmitted electronically to and from myself and my practitioner.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Limitations:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`Regardless of the sophistication of today's technology, some information my practitioner would ordinarily get in in-person therapy may not be available in teletherapy. I understand that such missing information could in some situations make it more difficult for my practitioner to understand my problems and to help me get better. My practitioner will be unable to physically touch me or to render any emergency assistance if experience a crisis.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Risks:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that Telebehavioral Health is a new delivery method for professional services, in an are not yet recognized.`} </li>
                        <li> {`Among the risks that are presently recognized is the possibility that the technology will fail before or during the therapy, that the transmitted information in any form will be unclear or inadequate for proper use in the therapy(s), and that the information will be intercepted by an unauthorized person or persons. `} </li>
                        <li> {`In rare instances, security protocols could fail, causing a breach of privacy or personal health information. I understand that a physical examination may be performed by individuals at my location at the request of the consulting practitioner`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Release of Information:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I authorize the release of any information pertaining to me determined by my practitioner, my other health care practitioners or by my insurance carrier to be relevant to the therapy (s) or processing of insurance claims, including but not limited to my name. Social Security number, birth date, diagnosis, treatment plan and other clinical or medical record information.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Discontinuing care:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that at any time. The therapy(s) can be discontinued either by me or by my designers or by my health care practitioners.`} </li>
                        <li> {`I further understand that I do not have to answer any question that I feel is inappropriate or whose answer I do not wish persons present to hear; that any refusal to participate in the therapy (s) or use of technology will not affect my continued treatment and that no action will be taken against me.`} </li>
                        <li> {`I acknowledge, however, that diagnosis depends on information, and treatment depends on diagnosis so if I withhold information, I assume the risk that a diagnosis might not be made or might be made incorrectly`} </li>
                        <li> {`Were that to happen, my telehealth-based treatment might be less successful than it otherwise would be, or it could fail entirely.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Limits of Confidentiality:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I also understand that, under the law, and regardless of what form of communication I use in working with my practitioner, my practitioner may be required to report to the authority's information suggesting that I have engaged in behavior that endanger self/others.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Alternatives:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`The alternatives to the therapy(s) have been explained to me, including their risks and benefits, as well as the risks and benefits of doing without treatment. I understand that I can still pursue in-person therapy. I understand that the Telebehavioral health therapy(s) does not necessarily eliminate my need to see a specialist in person, and I have received no guarantee as to the Telebehavioral therapy effectiveness.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Records:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that my Telebehavioral therapy(s) may be recorded and stored electronically as part of my medical records. I understand that therapy test results, and disclosures will be held in confidence subject to state and /or federal law.`} </li>
                        <li> {`I understand that I am ordinarily guaranteed access to my records and that copies of recorded of therapy(s) are available to me on my written request.`} </li>
                        <li> {`I also understand, however, that if my practitioner, in the exercise of professional judgment, concludes that providing my records to me could threaten the safety of a human being, myself or another person he or she may rightfully decline to provide them. I such a request is made and honored, I understand that I retain sole responsibility for the confidentiality of the records released to me and that I may have to pay a reasonable fee to get a copy.`} </li>
                        <li> {` Additionally, I understand that my records may be used for telehealth program evaluation, education, and research and that I will not be personally identified if such a use occurs. `} </li>
                        <li> {`I hereby authorize these disclosures to take place without prior written consent.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Compensation:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I understand that I am not entitled to royalties or to other forms of compensation for participation in any Telebehavioral therapy(s) or other information exchange.`} </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Contact Information:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li> {`I have received a copy of my practitioner's contact information, including his or her name, telephone number, and voice mail number, business address, mailing address, and e-mail address (if applicable)`} </li>
                        <li>{`I have also been provided with a list of local support services in case of an emergency. I am aware that my practitioner may contact the proper authorities and / or my designated, local contact person in case of an emergency.`}</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Release of Liability:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>{`I unconditionally release and discharge`} <b>Transformative Solutions LLC,</b> {`its affiliates, agents, employees;`} <b>Here's My Turning Point,</b> {`its affiliates, agents, and employees; and my practitioner and his or her designees from any liability in connection with my participation in the remote therapy(s)`}</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Emergency Care:</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>{`I acknowledge, however, that if I am facing or if I think I may be facing an emergency that could result in harm to me or to another person; I am not to seek Telebehavioral therapy. Instead,`}</li>
                        <li>{`I agree to seek care immediately through my own local health care practitioner or at the nearest hospital emergency department or by calling 911.`}</li>
                        <li>{`These are the names and telephone numbers of my local emergency contacts (including local physician; crisis hotline; trusted family, friend, or adviser)`}</li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Contact Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtContactNumber_1' name='txtContactNumber_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Contact Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtContactNumber_2' name='txtContactNumber_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Contact Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtContactNumber_3' name='txtContactNumber_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b><u>Final Agreement:</u></b>
                </p>
                <p className='w-750'>
                    {`I have read this document carefully and fully understand the benefits and risks. I have had the opportunity to ask any questions I have and have received satisfactory answers.`} <br />
                    {`With this knowledge, I voluntarily consent to participate in the Telebehavioral therapy(s) including but not limited to any care, treatment, and service deemed necessary and advisable, under the terms described herein.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b><u>Consent to Treat a Minor:</u></b>
                </p>
                <p className='w-750'>
                    The above release is given on behalf of <input type='text' id='txtNameOfMinorName_' name='txtNameOfMinorName_' placeholder='(Name of Minor)' className='add-only w-250 custom-add-only' /> because the patient is a minor,or has been determined to be incompetent to give medical consent.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature / Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>COST SHARING FEE AGREEMENT</u></h3>
                </p>
                <p className='w-750'>
                    {`We appreciate that you have chosen Here's My Tuning Point, LLC (HMTP) for your behavioral and/ or substance use needs. I understand that fees are charged for various services and that Here's My Turing Point, LLC (HMTP) will assist you throughout this process. I will provide necessary information to Here's My Turing Point, LLC (HMTP) to determine my eligibility for insurance plans, Medicaid or self-pay which is based on a sliding fee scale according to the rates set by Medicaid State of Ohio. I authorize payment to Here's My Turing Point, LLC (HMTP) from my insurance carrier for services provided`}
                </p>
                <p className='w-750'>No client will be denied services due to the inability to pay. </p>
                <p className='w-750'>
                    <ul>
                        <li>{`A Financial Responsibility Form is completed on each client during the admission process.`}</li>
                        <li>{`The sliding fee scale will be used to determine each client financial responsibility and payer status.`}</li>
                        <li>{`Medicaid and third-party payers will be identified and will be billed accordingly with the receipt of the proper identification and/or authorization.`}</li>
                        <li>{`First party payers (insurance coverage) will be responsible for payment of services.`}</li>
                        <li>{`Changes in coverage will notify For HMTP immediately if I have any changes or lapse in insurance coverage.`}</li>
                        <li>{`If a client insurance company reimburses only partially, the client will be responsible for paying any difference between the insurance company reimbursement and his/her sliding fee amount.`}</li>
                        <li>{`Each client and responsible party will sign and be given a copy of the Financial Responsibility Form.`}</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <u>Insurance coverage:</u>  The agency will attempt to bill your insurance company for services rendered, however, un-reimbursed expense and co-pays are your responsibility to pay at the time of service.
                </p>
                <p className='w-750'>
                    <u>Medical coverage:</u>   I understand that the agency will process the Medicaid claim for services rendered. I also understand that if I lose Medicaid during the course of treatment, a new fee agreement will be negotiated, and I will be expected to accept responsibility for the cost of my and/or my family's treatment.
                </p>
                <p className='w-750'>
                    <u>Contract services:</u>  As a client of Here's My Turing Point, LLC (HMTP), I understand that the agency will submit cost of services I have received to the appropriate agency for payment.
                </p>
                <p className='w-750'>
                    <u>Self-Pay:</u> <input type='checkbox' id='cbSelfPay_1' name='cbSelfPay_1' className='add-only' value='CheckBoxONLYIfSelfPay' /> (check box ONLY if self-pay)
                </p>

                <p className='w-750'>As a client of Here's My Turning Point, LLC (HMTP), I understand that I am responsible for paying the daily costs of my treatment, based on my annual reported income and number of dependents as measured against the sliding fee scale I am <br />
                    expected to pay, see the table of services below: </p>
                <p className='w-750'> Non-payment In an effort to adopt a policy that will be applied equitably to all agency clients, the following guidelines will  be followed:

                </p>
                <p className='w-750'>
                    <ul>
                        <li>All clients are expected to pay their fees/copays at the time of service.</li>
                        <li>{`Clients who have an outstanding balance of $200.00 or more will be notified that they must pay at least $20.00 of this balance in addition to their co-pay/fee at each appointment.`}</li>
                        <li> Non-payment may result in suspension of services, to include all future appointments until the client presents with payment.</li>
                        <li>Appointments will be scheduled after receipt of payment due</li>
                        <li>Should 45 days lapse without payment, the client will be notified of pending discharge, 30 days from the date of letter unless payment due is received.</li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'>SERVICE</span></td>
                        <td className='w-150'> <span className='eleHeader'>HOUR SESSION</span></td>
                        <td className='w-250'> <span className='eleHeader'>PRICE</span></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'> </td>
                        <td className='w-150'> </td>
                        <td className='w-125'><b>OFFICE</b></td>
                        <td className='w-125'><b>COMMUNITY</b></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Individual Psychotherapy</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>115.35</td>
                        <td className='w-125'>115.35</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Group Psychotherapy</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>115.35</td>
                        <td className='w-125'>115.35</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Family Psychotherapy</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>88.12</td>
                        <td className='w-125'>88.12</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Diagnostic Evaluation</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>125.28</td>
                        <td className='w-125'>125.28</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>CPST</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>88.12</td>
                        <td className='w-125'>88.12</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>TBS</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>101.32</td>
                        <td className='w-125'>128.96</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Psychosocial Rehabilitation</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>71.44</td>
                        <td className='w-125'>91.64</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Assertive Community Treatment</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>284.03</td>
                        <td className='w-125'>284.03</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Intensive Home-Based Therapy</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>87.08</td>
                        <td className='w-125'>87.08</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Substance Use Disorder Assessment & ASAM</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>87.07</td>
                        <td className='w-125'>87.07</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Substance Use Disorder Services</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>88.12</td>
                        <td className='w-125'>88.12</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-350'>Intensive Outpatient Treatment</td>
                        <td className='w-150'>1 HOUR</td>
                        <td className='w-125'>87.08</td>
                        <td className='w-125'>87.08</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'> <h3>Confidentiality Statement</h3> </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Client Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClientNumber' name='txtClientNumber' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`HMTP shall protect the confidentiality of all clients in compliance with federal law (42 U.S.C. 290DD-3 and 42 U.S.C. 290EE-3) and regulations (42 C.F.R. Part 2) and the Health Insurance Portability and Accountability Act of 1996.`}
                </p>
                <p className='w-750'>
                    {`Client information will not be released unless the requesting party or agency submits to HMTP a signed form or legal document from the person to whom the request pertains. Here's My Turning Point staff shall not convey to a person outside of the program that a client attends or receives services from the program or disclose any information identifying a client as an alcohol or other drug prevention services client unless the client consents in writing for the release of information, the disclosure is allowed by a court order, or the disclosure is made to a qualified personnel for a medical emergency, research, audit or program evaluation purposes`}
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Federal laws and regulations do not protect any threat to commit a crime, any information about a crime
                            committed by a client either at the agency or against any person who works for the agency</li>
                        <li>Federal laws and regulations do not protect any information about suspected child abuse or neglect from
                            being reported under state law to appropriate state or local authorities</li>
                    </ol>
                </p>
                <table>
                    <tr>
                        <td className='w-10'></td>
                        <td className='w-740'>All written requests for client information are to be made part of the client's official file</td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-730'>The Director will approve all written request for client information.</td>
                    </tr>
                </table>
                <p className='w-750'>
                    If these factors apply below, then confidentiality can be breached:
                </p>
                <p className='w-750'>
                    <ol start={3}>
                        <li>if I am deemed to present danger to myself or others</li>
                        <li>if concerns about possible abuse or neglect arise</li>
                        <li>to medical personnel in a medical emergency or to qualified personnel for research, audit, or program evaluation</li>
                        <li>if I commit a crime on HMTP property, including agency vehicles, and/or against HMTP or its employees</li>
                    </ol>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature of Client: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature of Patient or Parent/Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Staff/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>AUTHORIZATION FOR TRANSPORTATION</u></h3>
                </p>
                <p className='w-750'>
                    {`As part of the services provided by Here's My Turing Point, LLC. (HMTP), I understand that there may be occasions when I and/or my child will be transported to participate in education, cultural, therapeutic and/or recreational activities. I authorize Here's My Turing Point, LLC. (HMTP) staff and/or volunteers to provide transportation for me/them, and understand that Here's My Turing Point, LLC. (HMTP) is exempt from any liability and/or damage.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent and/or Legal Guardian Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Staff  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGoalStatusThree_1' name='cbGoalStatusThree_1' className='add-only' value='IRefuseAuthorizeMyTurningPoint' /> I refuse to authorize Here's My Turing Point, LLC. to transport myself and/or my minor child(ren)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <hr />
                </p>
                <p className='w-750'>
                    <h3><u>MEDICAL Emergency</u></h3>
                </p>
                <p className='w-750'>
                    {`I understand Here's My Turing Point, LLC. (HMTP) will make every effort to inform me, as soon as possible of a medical emergency. I acknowledge that Here's My Turing Point, LLC. (HMTP) assumes no financial responsibility for the cost of mine and/or my child's medical care. Please indicate one of the following:`}
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedicalEmergency' name='cbMedicalEmergency' className='add-only' value='IfEmergencyMedicalAttentionNeeded' />{`If emergency medical attention is needed by`} <u>me or my child,</u> {` I authorize Here's My Turing Point, LLC. (HMTP) to obtain the necessary emergency medical attention and`} <u> have the condition evaluated and treated until my emergency contact can be reached.</u>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h3>OR</h3>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedicalEmergencyOne' name='cbMedicalEmergencyOne' className='add-only' value='IfEmergencyMedicalAttentionByNeeded' />{`If emergency medical attention is needed by`} <u>me or my' child,</u> {`Here's My Turing Point, LLC. (HMTP) should make reasonable efforts to contact my emergency contact`} <u> prior to obtaining necessary emergency medical attention.</u>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center><h3>{`**CHECK ONE OPTION ABOVE**`}</h3></center>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature of Client: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature of Patient or Parent/Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Staff/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>DISTURBURTE TO SUD CLIENTS ONLY</h3> <br />
                    42 C.F.R PART 2
                </p>
                <p className='w-750'>
                    {`This information has been disclosed to you from records protected by federal confidentiality rules (42 CFR part 2). The federal rules prohibit staff of Here's My Turning Point, (HMTP) from making any further disclosure of information in this record that identifies a patient as having or having had a substance use disorder either directly, by reference to publicly available information, or through verification of such identification by another person unless further disclosure is expressly permitted by the written consent of the individual whose information is being disclosed or as otherwise permitted by 42 CFR part 2. A general authorization for the release of medical or other information is not sufficient for this purpose (see 42 CFR 2.31).`}
                </p>
                <p className='w-750'>
                    {`The federal rules restrict any use of the information to investigate or prosecute with regard to a crime any patient with a substance use disorder, except as provided at 42 CFR 2.12(c)(5) and 42 CFR 2.65; or, *42 CFR part 2 prohibits unauthorized disclosure of these records`}
                </p>
                <p className='w-750'>
                    {`HMTP will not condition treatment, payment, enrollment, or eligibility on client's authorization for the release of information, or a statement of the consequences to the client if client refuses to sign an authorization for the release of information.`}
                </p>
                <p className='w-750'>
                    {`For records relating to addiction services, information from other providers that is contained in the individual client record may be released from the individual client record only if the written authorization provided in accordance with this rule explicitly authorizes both the disclosure of provider's records and the re-disclosure of the other provider's records. Please see Release of Information.`}
                </p>
                <p className='w-750'>
                    <hr />
                </p>
                <p className='w-750'>
                    <center> <b>The following is applicable if the client is a minor:</b> </center>
                </p>
                <p className='w-750'>
                    {`Minor client's providing consent to treatment pursuant to section 3719.012 of the Revised Code, the client shall sign the release of information`}
                </p>
                <p className='w-750'>
                    {`When providing services to clients who are minors but who are not providing consent pursuant to section 3719.012 of the Revised code; HMTP MUST DO ONE OF THE FOLLOWING:`}
                </p>
                <p className='w-750'>
                    <ul>
                        <li>obtain the client's authorization to contact the client's parent or legal guardian</li>
                    </ul>
                    <center>OR</center>
                    <ul>
                        <li>{`find the minor lacks in capacity to make a rational choice in accordance with 42 C.F.R. part 2.14(c)(2).`}</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b>Federal laws and regulations do not protect any information about suspected child abuse or neglect from being reported under State law to appropriate State or Local authorities.</b>
                </p>
                <p className='w-750'>
                    <h3><u>Authorization to Disclose/Obtain Confidential Information</u></h3>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name of Client:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtNameOfClient' name='txtNameOfClient' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirthClient' name='txtDateOfBirthClient' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`In accordance with Federal Regulations 42 CFR, Part 2, and HIPPA, I hereby authorize to have:`}
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            Here's My Turning Point, LLC (HMTP) <br />
                            2345 Dorr Street <br />
                            Toledo, Ohio 43607
                        </td>
                        <td className='w-375'>
                            Obtain records from and/or disclose or disclose to:<br />
                            Name of Individual/Entity to whom disclosure is
                            <input type='text' id='txtNameOfIndividualDisclosure' name='txtNameOfIndividualDisclosure' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Identify and describer nature/extent/type of information to be disclosed:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_1' name='cbIdentifyDescribeNatureExtent_1' className='add-only' value='ProgressNotes' /> Progress Notes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_2' name='cbIdentifyDescribeNatureExtent_2' className='add-only' value='DiagnosticAssessment' /> Diagnostic Assessment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_3' name='cbIdentifyDescribeNatureExtent_3' className='add-only' value='LabResults' /> Lab Results
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_4' name='cbIdentifyDescribeNatureExtent_4' className='add-only' value='PsychiatricEvaluation' />Psychiatric Evaluation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_5' name='cbIdentifyDescribeNatureExtent_5' className='add-only' value='PhysicalHealthNotes' /> Physical Health Notes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_6' name='cbIdentifyDescribeNatureExtent_6' className='add-only' value='TreatmentPlan' /> Treatment Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_7' name='cbIdentifyDescribeNatureExtent_7' className='add-only' value='MedicationOrders' /> Medication Orders
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_8' name='cbIdentifyDescribeNatureExtent_8' className='add-only' value='DischargeTermination' /> Discharge Termination
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_9' name='cbIdentifyDescribeNatureExtent_9' className='add-only' value='DrugScreenResults' /> Drug Screen Results
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_12' name='cbIdentifyDescribeNatureExtent_12' className='add-only' value='AlcoholDrug' /> Alcohol/Drug
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_10' name='cbIdentifyDescribeNatureExtent_10' className='add-only' value='SubstanceUseAssessments' /> Substance Use Assessments
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtent_11' name='cbIdentifyDescribeNatureExtent_11' className='add-only' value='IndividualizedTreatmentPlan' /> Individualized Treatment Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIdentifyDescribeNatureExtentOther' name='cbIdentifyDescribeNatureExtentOther' className='add-only' value='IdentifyDescribeNatureExtentOther' />Other:
                            <input type='text' id='txtIdentifyDescribeNatureExtentother' name='txtIdentifyDescribeNatureExtentother' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <hr />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>For the time period of: (Choose one only)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbForTheTimePeriod_MostrecentAdmission' name='rbForTheTimePeriod' className='add-only' value='MostrecentAdmission' /> Most recent Admission
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbForTheTimePeriod_AllAdmissions' name='rbForTheTimePeriod' className='add-only' value='AllAdmissions' /> All Admissions
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbForTheTimePeriod_PreviousThreeMonths' name='rbForTheTimePeriod' className='add-only' value='PreviousThreeMonths' /> Previous Three Months
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbForTheTimePeriod_SpecificTimePeriodFrom' name='rbForTheTimePeriod' className='add-only' value='SpecificTimePeriodFrom' /> Specific Time Period from
                            &nbsp;<input type='date' id='txtForTheTimePeriodDateFrom' name='txtForTheTimePeriodDateFrom' className='add-only w-150 custom-add-only' /> To
                            &nbsp;<input type='date' id='txtForTheTimePeriodDateTo' name='txtForTheTimePeriodDateTo' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`Including psychiatric records related to emotional illness, and information regulated by federal public law 930-282, Confidentiality of Alcohol and Drug Abuse Patients. Also included are records documenting the diagnosis and/or treatment of AIDS, ARC, HIV Positive and other related diseases.`}
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PURPOSE FOR DISCLOSURE (CHECK ONE OR MORE)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeForDisclosure_1' name='cbPurposeForDisclosure_1' className='add-only' value='ComprehensiveTreatment' /> Comprehensive Treatment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeForDisclosure_2' name='cbPurposeForDisclosure_2' className='add-only' value='FamilyInvolvement' /> Family Involvement
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeForDisclosure_3' name='cbPurposeForDisclosure_3' className='add-only' value='Followup' /> Follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeForDisclosure_4' name='cbPurposeForDisclosure_4' className='add-only' value='LegalConcerns' /> Legal Concerns
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeForDisclosure_5' name='cbPurposeForDisclosure_5' className='add-only' value='ContinuityOfCare' /> Continuity of Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurposeForDisclosureOther' name='cbPurposeForDisclosureOther' className='add-only' value='PurposeForDisclosureOther' />Other:
                            <input type='text' id='txtPurposeForDisclosureother' name='txtPurposeForDisclosureother' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b><u>Re-Disclosure:</u></b>
                </p>
                <p className='w-750'>
                    {`The confidentiality of the information being disclosed is protected by State and Federal law. ORC 5122.31, ORC 3701.243 and 42 CFR part 2 5122-27-06 10 (a & b) prohibit you from making any further disclosure of it without the specific and informed release of the individual to whom it pertains, his/her authorized representative, or as otherwise permitted by law. This information has been disclosed to you from records protected by Federal Confidentiality Rules (42 CFR part 2). The Federal Rules prohibit you from making any further disclosure of this information unless further disclosure is expressly permitted by the written consent of the person to whom it pertains to as otherwise permitted by 42 CFR part 2. A general authorization for the release of medical or other information is NOT sufficient for this purpose.`}
                </p>
                <p className='w-750'>
                    <b>I expect to continue receiving treatment services to a maximum of one year (365 days) or at termination, (whichever is sooner)</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Expiration Date:</span>
                            <span className='small'>(Check the appropriate box) </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbExpirationDateAbout_Months' name='rbExpirationDateAbout' className='add-only' value='Months' /> 6 Months &nbsp;
                            <input type='radio' id='rbExpirationDateAbout_Year' name='rbExpirationDateAbout' className='add-only' value='Year' /> 1 Year &nbsp;
                            <input type='radio' id='rbExpirationDateAbout_Discharge' name='rbExpirationDateAbout' className='add-only' value='Discharge' /> Discharge
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    For client receiving addiction services, <br />
                    “42 CFR part 2 prohibits unauthorized disclosure of these records”. The Federal Rules restrict any use of information to criminally investigate or prosecute any alcohol or drug abuse client
                </p>
                <p className='w-750'>
                    <b><u>Extension of Expiration:</u></b>
                </p>
                <p className='w-750'>
                    {`I understand Here's My Turning Point, LLC may not condition treatment, payment, enrollment or eligibility for benefits on whether individual sign this authorization. This information has been disclosed to you from record protected by federal confidentiality rules. The federal rules prohibit you from making any further disclosure of this information unless further disclosure is expressly permitted by the written consent of the person to whom it pertains to or as otherwise permitted by 42 CFR part 2, 5122-27-07 (10) a & b general authorization for the release of medical or other information is not sufficient for this purpose. The federal rules restrict any use of information to criminally investigate or prosecute any mental health and/or alcohol or drug abuse client`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-275'>&nbsp; </td>
                        <td className='signature w-275'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-275'>Print name of staff facilitating request</td>
                        <td className='small w-275'>Staff Signature</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-275'>&nbsp; </td>
                        <td className='signature w-275'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-275'>Client Signature</td>
                        <td className='small w-275'>Parent/Guardian Signature (if applicable)</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Revocation if/when requested:</b> Client can at any time revoke this release. Except to the extent that the provider has acted on the release within 48 hours
                </p>
                <p className='w-750'>
                    I <input type='text' id='txtHereByRevokeConsent' name='txtHereByRevokeConsent' className='add-only w-350 custom-add-only' />, hereby revoke this consent for release of above information on (date)&nbsp;<input type='date' id='txtDateAbove' name='txtDateAbove' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3><u>Client's Rights</u> </h3>
                </p>
                <p className='w-750'>
                    (Ohio Department of Mental Health & Addiction Services)
                </p>
                <p className='w-750'>
                    <ol>
                        <li>The right to be treated with consideration and respect for personal dignity, autonomy, and privacy.</li>
                        <li>The right to reasonable protection from physical, sexual, or emotional abuse, neglect, and inhumane treatment.</li>
                        <li>The right to receive services in the least restrictive, feasible environment.</li>
                        <li>The right to participate in any appropriate and available service that is consistent with an ITP, regardless of the refusal of any other service, unless that service is a necessity for clear treatment reasons and requires the person's participation.</li>
                        <li>The right to give informed consent to or to refuse any service, treatment, or therapy, including medication absent an emergency.</li>
                        <li>The right to participate in the development, review, and revision of one's own individualized treatment plan and receive a copy of it.</li>
                        <li>The right to freedom from unnecessary or excessive medication, and to be free from restraint or seclusion unless there is immediate risk of physical harm to self or others.</li>
                        <li>The right to be informed and the right to refuse any unusual or hazardous treatment procedures.</li>
                        <li>The right to be advised and the right to refuse observation by others and by techniques such as one-way vision mirrors, tape recorders, video recorders, television, movies, photographs or other audio and visual technology. This right does not prohibit an agency from using closed-circuit monitoring to observe seclusion rooms or common areas, which does not include bathrooms or sleeping areas</li>
                        <li>The right to confidentiality of communications and personal identifying information within the limitations and requirements for disclosure of client information under state and federal laws and regulations.</li>
                        <li>The right to have access to one's own client record unless access to certain information is restricted for clear treatment reasons. If access is restricted, the treatment plan shall include the reason for the restriction, a goal to remove the restriction, and the treatment being offered to remove the restriction.</li>
                        <li>The right to be informed a reasonable amount of time in advance of the reason for terminating participation in a service, and to be provided a referral, unless the service is unavailable or not necessary</li>
                        <li>The right to be informed of the reason for denial of a service.</li>
                        <li>The right not to be discriminated against for receiving services based on race, ethnicity, age, color, religion, gender, national origin, sexual orientation, physical or mental handicap, developmental disability, genetic information, human immunodeficiency virus status, or in any manner prohibited by local, state, or federal laws.</li>
                        <li>The right to know the cost of services.</li>
                        <li>The right to be verbally informed of all client rights, and to receive a written copy upon request</li>
                        <li>The right to exercise one's own rights without reprisal, except that no right extends so far as to supersede health and safety considerations.</li>
                        <li>The right to file a grievance.</li>
                        <li>The right to have oral and written instructions concerning the procedure for filing a grievance, and to assist in filing a grievance if requested.</li>
                        <li>The right to be informed of one's own condition.</li>
                        <li>The right to consult with an independent treatment specialist or legal counsel at one's own expense.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    In addition to the rights listed, no person will be denied admission to a program due to their use of prescribed psychotropic medications. This Patient rights and grievance policy will be given to each Patient at admission, with documentation kept in the Patient's record, and the policy will be posted at each program site in a place accessible to Clients. All Staff will receive and review a copy of the Client's Rights and Grievance Policy and documentation of staff's agreement to abide by the policy and procedure will be kept in their personnel files.
                </p>
                <p className='w-750'>
                    <b><u>{`Compliant/Grievance Client Procedure`}</u></b>
                </p>
                <p className='w-750'>
                    Upon admission, each client will be provided with a copy of the client grievance and appeal procedures that will be provided in the client handbook. Upon written request any other person may receive a copy of the policy and procedure. <u>Receipt of the client grievance and appeal procedure is documented by client's dated signature in his/her individual client record.</u>  The grievance process will be shared with all clients in a manner that is understandable.
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Client complaints/grievances should be filed with the Owner and/or Director. A contact telephone number for the Owner and/or Director is listed on posters prominently displayed at each service location. Complaint forms are available at each service location. Complaints may be made in person or by telephone. The Client Rights Officer will assist patient in making a complaint if help is requested and will provide all the necessary information about complaint and appeal procedures.</li>
                        <li>The complaint form must be submitted to the CO listed on the Client Rights Poster: The Client Rights Officer who will be available to assist a client in filing of a grievance, the client rights officer shall have their name, title, location, hours of availability, and telephone number included with posting of client rights.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <h3><u>Grievance Procedure:</u></h3>
                </p>
                <p className='w-750'><ol>
                    <li>If conflict between a client and his/her legal guardian and/or agency arises concerning the treatment plan or services, the primary counselor will first attempt to facilitate a resolution.</li>
                    <li>Should a resolution at this level not occur, the counselor's supervisor will intervene and assist in seeking a resolution.</li>
                    <li>If a problem cannot be resolved at a staff level, any client or family member may initiate a grievance at his/her discretion by requesting a grievance form from any staff person. Should the client need assistance in completing the grievance form, the Director will assist in the preparation and filing of a grievance. All grievances will be submitted to the Owner.{`r. *** Here's My Turning Point will make a resolution decision on the grievance within`} <b>twenty business days</b>{` of receipt of the grievance. Any extenuating circumstances indicating that this time-period will need to be extended must be documented in the grievance file and written notification given to the client. ***`} </li>
                    <li>All grievances must be signed and dated by the client or person completing the grievance form, and include the date, time, description of the incident, and the names of the individuals involved. The Client Rights Advocate will make a grievance resolution.</li>
                    <ol type='a'>
                        <li>Date grievance was received.</li>
                        <li>Summary of grievance</li>
                        <li>Overview of grievance investigation process</li>
                        <li>Timetable for completion investigation and notification of resolution.</li>
                        <li>Treatment providers contact name, address, and telephone number.</li>
                    </ol>
                    <li>Within <b>three business days</b> of receipt, a written acknowledgment of the receipt of the grievance be provided to each grievant. Such acknowledgement shall be provided within three business days from the receipt of the grievance. The written acknowledgment shall include:
                    </li>
                    <ol type='a'>
                        <li>Date grievance was received</li>
                        <li>Approximate time of incident.</li>
                        <li>Summary/Description of the incident</li>
                        <li>Overview of the grievance investigation process</li>
                        <li>Time frame for completion of investigation and notification of resolution</li>
                        <li>The names of individuals involved in the incident or situation to be grieved.</li>
                        <li>Treatment providers contact name, address and telephone number.</li>
                    </ol>
                </ol>
                </p>
                <p className='w-750'>
                    A statement will be included that reads the program will make a resolution decision on the grievance within twenty business days of receipt of the grievance. Any extenuating circumstances indicating that this time-period will need to be extended must be documented in the grievance file and written notification given to the client
                </p>
                <p className='w-750'>
                    HMTP will maintain for two years the records of written grievances. These records will include a copy of the grievance, documentation of the grievance resolution, and a copy of the letter to the grievant reflecting the resolution. Grievances and appeals filed are reviewed annually by leadership to determine trends in complaints and identify areas for performance improvement.
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Both client and his/her family members may utilize the existing grievance procedures if desired. The person served may make a formal complaint, file a grievance, or appeal a decision made by HMTP staff members or team.</li>
                        <li>Filing a complaint or grievance action will not result in barriers to service</li>
                        <li>Grievance forms and procedures are made readily available to the persons served.</li>
                        <li>HMTP will arrange for annual mandatory staff training on the client/consumer's grievance procedures</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Client has the option to file a grievance with outside organizations, that include, but not limited to, the following, with the mailing address and telephone numbers for each stated:</u></b>
                </p>
                <p className='w-750'>
                    <h3><u>Clients may file a grievance with any of the following agencies:</u></h3>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            Lucas County Mental Health and Recovery <br />
                            Services Board <br />
                            {`701 Adams St # 800, Toledo, OH 43604`} <br />
                            Toledo, OH 43604 <br />
                            419-213-4600 <br />
                            <a href=' https://www.lcmhrsb.oh.gov/' >  https://www.lcmhrsb.oh.gov/</a>
                        </td>
                        <td className='w-375'>
                            Ohio Civil Rights Commission <br />
                            Toledo Regional Office <br />
                            One Government Center <br />
                            Room 936 <br />
                            Jackson & Erie Streets <br />
                            Toledo, Ohio 43604 <br />
                            419-245-2900 <br />
                            TTY:614-752-2391
                        </td>
                    </tr>
                    <hr />
                    <tr>
                        <td className='w-375'>
                            Ohio Department of Mental Health & <br />
                            Addiction Services <br />
                            The James A. Rhodes State Office Tower <br />
                            30 East Broad Street,8th Floor <br />
                            Columbus, OH 43215-3430 <br />
                            614-466-2596 <br />
                            TTY 614-752-9696 <br />
                        </td>
                        <td className='w-375'>
                            U.S. Department of Health & Human <br />
                            Services <br />
                            233 North Michigan Avenue, Ste. 1300 <br />
                            Chicago, IL 60601 <br />
                            Phone: 312-353-5160 <br />
                        </td>
                    </tr> <hr />
                    <tr>
                        <td className='w-375'>
                            Disability Rights of Ohio <br />
                            200 S. Civic Center # 300 <br />
                            Columbus, Ohio 43215 <br />
                            Monday-Friday 9am-12pm and 1pm-4pm <br />
                            Phone number: 1.800.282.9181 <br />
                            614.466.7264 <br />
                            <a href=' https://www.disabilityrightsohio.org' >  https://www.disabilityrightsohio.org</a>
                        </td>
                        <td className='w-375'>
                            Here's My Turning Point <br />
                            Client Rights Officer <br />
                            Sharon Daughtery <br />
                            419-290-8656 <br />
                            Monday 12pm-4pm <br />
                            Wednesday 12pm-6pm <br />
                            Thursday 1pm-5pm
                        </td>
                    </tr> <hr />
                </table>
                <p className='w-750'>
                    <b> <u>APPEALING A DECISION</u> </b>
                </p>
                <p className='w-750'>
                    The decision about a grievance is called a resolution. If someone is not satisfied with the decision or answer, he or she can appeal. An appeal is a request for a review of the answer.
                </p>
                <p className='w-750'>{`To appeal an`} <b>agency's</b> {`answer to your grievance, contact your county's Mental Health Board online or call 614-224-1111.`} </p>
                <p className='w-750'>
                    <ol>
                        <li>Ask for the patient rights officer (PRO) at the mental health board.</li>
                        <li>Tell the PRO that you want to file an appeal on the agency's answer to your grievance.</li>
                        <li>If you are not satisfied with their response, you can appeal their decision to the Ohio Department of Mental Health & Addiction Services (Ohio MHAS) using the instructions below.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    To appeal a <b>hospital or mental health board's</b> {`answer to your grievance, contact Ohio MHAS's Community Supports and Patient's Rights Office via e-mail (CAP) or call (877) 275-6364 (family and patient only), (614) 466-7228 (all others), TTY (888) 636-4889.`}
                </p>
                <p className='w-750'>
                    <ol>
                        <li>
                            Ask to speak with the Office of Community Supports and Patient's Rights.
                        </li>
                        <li>
                            Tell them you want to file an appeal on the hospitals or county mental health board's answer to your grievance.
                        </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>ASSISTANCE</b>
                </p>
                <p className='w-750'>
                    {`If you need assistance at any time during the grievance or appeal process, contact one of the agencies listed below. For agencies with no TTY/TDD number listed, call the Ohio Relay Service TTY at 711 or 800-750-0750`}
                </p>
                <p className='w-750'>
                    <b>Disability Rights Ohio</b>  <br />
                    800-282-9181 / TTY 800-858-3542
                </p>
                <p className='w-750'>
                    <b>Community Patient Rights Advocates by County </b> <br />
                    <b>OhioMHAS Patient Advocacy and Protection Specialist</b>
                </p>
                <p className='w-750'>
                    877-275-6364 (family and patient only) <br />
                    614-466-7228 (all others) <br />
                    TTY 888-636-4889
                </p>
                <p className='w-750'>
                    Here's My Turning Point<br />
                    Owner and/or Director <br />
                    2345 Dorr Street <br />
                    Toledo, Ohio 43607 <br />
                    Office Phone # 419.407.5342 <br />
                    Office Fax # 419.407.5371
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>Program & Provider Service Overview</u></h3>
                </p>
                <p className='w-750'>
                    HMTP services are available to substance use disorders and behavioral health regardless of ethnicity, sexual orientation, religious affiliation, or ability to pay. The intake/admission process provides services based on the HMTP mission, vision, values, and guiding principles as well as the needs of prospective clients and the community. Intake services are organized in a response to client's needs (emergency, urgent, routine) as identified through the planning process of effective and efficient access to services. HMTP services will be delivered by eligible providers that meet the criteria.
                </p>
                <p className='w-750'>
                    A comprehensive diagnostic assessment shall be completed for all clients in a manner that is respectful and considerate of the person's specific needs. HMTP Provider Service Plan shall be available for review by persons served, their families, significant others, and the public. The initial diagnostic assessment must be completed prior to the initiation of any treatment services, with the only exceptions being crisis intervention or medical services as a least restrictive alternative in an emergency
                </p>
                <p className='w-750'>
                    General services are the assessment activities, medical activities, and counseling therapy activities defined in this rule. The general services shall be provided by the professional credentials within the scope of practice oof those credentialed professionals.
                </p>
                <p className='w-750'>
                    <ol>
                        <li> Assessment activities: </li>
                        <ol type='a'>
                            <li>Is a clinical evaluation of person which is:</li>
                            <ol type='i'>
                                <li>Individualized</li>
                                <li>Age, gender, and culturally appropriate</li>
                            </ol>
                            <li>A diagnosis will be determined, treatment needs, and establish a treatment plan to
                                address the persons mental illness or substance use disorder</li>
                        </ol>
                        <li>The assessment will be provided to a client, and it will be started prior to the initiation of other services, except for emergency situations.</li>
                        <li>An initial assessment will include an evaluation of:</li>
                        <ol type='a'>
                            <li>The presenting problem</li>
                            <li>The risk of harm to self or others</li>
                            <li>The use of alcohol or drugs</li>
                            <li>The treatment history for mental health illness or substance use/abuse</li>
                            <li>A medical history and examination (mental status) or physical.</li>
                        </ol>
                    </ol>
                </p>
                <p className='w-750'>
                    <b><u>Individualized Treatment Plan (ITP) </u></b>
                </p>
                <p className='w-750'>
                    The development of the ITP is a collaborative process between the client and your case manager and/or therapist based on the diagnostic assessment, a continuing assessment of needs, and the identification of interventions and services appropriate to the individual diagnosis and other related items. The ITP and addiction treatment case management plan of care shall document, at minimum, the following:
                    <ol>
                        <li>A description of the specific mental health or addictive services and supports needs of the client.</li>
                        <li>Each client will have an Individualized Treatment Plan (ITP) developed during the clinical diagnostic assessment, or within seven (7) days of initial visit, or on the next face-to-face visit not to exceed 30 days.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b><u>Research and Evaluation</u></b>
                </p>
                <p className='w-750'>
                    HMTP will abide by OAC 5122-28-05, and we will ensure that research and evaluation activities are conducted in an ethical manner, that each participant's rights regarding such activities are respectedand protected, and that evaluation activities enhance the overall performance of the provider. Research activities shall be evaluated by and adhered to the requirements of an independent institutional review board. Evaluation activities shall be conducted in accordance with the requirements of a nationally recognized accrediting body, such as the American Evaluation Association
                </p>
                <p className='w-750'>
                    <b><u>Mental Health Day-Treatment</u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide mental health day-treatment as an intensive, structured, goal-oriented, distinct, and identifiable treatment service that utilizes multiple mental health interventions addressing the individualized mental health needs of the client as identified in their Individualized Treatment Plan (ITP). Mental health day-treatment services are clinically indicated by assessment with clear admission and discharge criteria. The environment at this level of treatment is highly structured and there should be an appropriate staff-to-client ratio to guarantee sufficient therapeutic services and professional monitoring, control, and protection

                </p>
                <p className='w-750'>
                    HMTP's purpose and intent for the mental health day-treatment is to stabilize, increase, or sustain the highest level of functioning and promote movement to the least restrictive level of care.
                </p>
                <p className='w-750'>
                    HMTP's outcome is for the individual to develop the capacity to continue to work towards an improved quality of life with the support of an appropriate level of care.
                </p>
                <p className='w-750'>
                    The minimum program length of this service shall be in accordance with the appropriate behavioral health standards of the agency's national accrediting body(ies). Mental health day-treatment program shall consist of a minimum of two hours and up to a maximum of seven hours and four days of scheduled, intensive activities that may include, but are not limited to the following:
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Determination of needed mental health interventions.</li>
                        <li>Skills development.</li>
                        <li>Interpersonal and social competency as age, developmentally and clinically appropriate, such as:</li>
                        <ol type='a'>
                            <li>Functional relationships with adults</li>
                            <li>Functional relationships with peer</li>
                            <li>Functional relationship with the community/schools.</li>
                            <li>Functional relations with employer/family.</li>
                            <li>Functional relations with authority figures.</li>
                        </ol>
                        <li>Obtain these skills:</li>
                        <ol type='a'>
                            <li>Problem solving.</li>
                            <li>Conflict resolution.</li>
                            <li>Emotions</li>
                            <li>Behavior management.</li>
                            <li>Developing positive coping mechanisms.</li>
                            <li>Ways of managing mental health and behavioral symptoms to enhance vocational/school opportunities and/or independent living.</li>
                        </ol>
                    </ol>
                </p>
                <p className='w-750'>
                    HMTP will provide psycho-educational interventions including individualized instruction and training of persons served to increase their knowledge and understanding of their psychiatric diagnosis(es), prognosis(es), treatment, and rehabilitation to enhance their acceptance of these psychiatric disabilities, increase their cooperation and collaboration with treatment and rehabilitation, improve their coping skills, and favorably affect their outcome.
                </p>
                <p className='w-750'>
                    <b><u>Counseling and Therapy (Group)</u></b>
                </p>
                <p className='w-750'>
                    HMTP will deliver counseling and therapy services and this interaction with a person or persons where the focus is on achieving treatment objectives related to alcohol and other substances, or the persons mental illness or emotional disturbance. HMTP will provide counseling and therapy services that will involve face-to-face encounters between a client, group of clients, client and family members, or family members and a behavioral health professional. Group counseling and therapy encounters may not exceed a one-to-twelve behavioral health professional to patient ratio.
                </p>
                <p className='w-750'>
                    <b><u>Medical Activities</u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide/deliver medical activities which are those activities that are performed within the professional scope of practice by staff that are licensed or certified by the State Medical Board of Ohio, the State of Ohio Board of Nursing, or pharmacist licensed by Pharmacy; and are intended to address the behavioral and other physical health needs of clients receiving treatment for psychiatric symptoms or substance use disorders.
                </p>
                <p className='w-750'>
                    Medical activities include (but not limited to) the following:
                    <ol>
                        <li>Performing health care screenings, assessments, and exams.</li>
                        <li>Checking vital signs.</li>
                        <li>Ordering laboratory test and reviewing the results.</li>
                        <li>Medication prescribing, administering, and monitoring.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b><u>Substance Use Disorder (SUD)- Case Management </u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide substance use disorder case management services to all its clients based on the client's treatment plan. Case management activities means those activities provided to assist and support individuals in gaining access to needed medical, social, educational, and other services essential to meeting basic human needs. Case management services may include interactions with  family members, other individuals, or entities.
                </p>
                <p className='w-750'>
                    Case management service shall include, at a minimum, the following:
                    <ol>
                        <li>Assessment</li>
                        <li>Referral</li>
                        <li>Monitoring and follow-up</li>
                    </ol>
                </p>
                <p className='w-750'>
                    Examples of case management activities include:
                    <ol>
                        <li>Coordinating client assessment, treatment planning, and crisis intervention services.</li>
                        <li>Providing training and facilitating linkages for the use of community resources.</li>
                        <li>Monitoring service delivery</li>
                        <li>Obtaining or assisting individuals in obtaining necessary services (i.e.: financial or housing assistance, food, clothing, medical, educational, vocational, and recreational services, etc.).</li>
                        <li>Assisting individuals in becoming involved with self-help support groups</li>
                        <li>Assisting individuals in increasing social support networks with family members, friends, and/or organizations</li>
                        <li>Assisting individuals in performing daily living activities.</li>
                        <li>Coordinating criminal justice services.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b><u>Addiction Treatment Level of Care/Intensive Outpatient (IOP)</u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide Addiction Treatment level of Care/IOP as a comprehensive array of services to persons who have behavioral health and/or substance use disorders and their families. The services are based on a system of care and the OMHAS Level of Care Protocols which enable HMTP to manage the client's care in the service continuum from access to discharge. The system of care and level of care protocols enable HMTP to:
                    <ul>
                        <li>Determine the necessity of services at admission/continued stay/discharge</li>
                        <li>Determine the appropriate level of care and if any changes in care are recommended</li>
                        <li>Perform multi-dimensional assessment utilizing the American Society of Addiction Medicine (ASAM) patient placement criteria.</li>
                        <li>Triage and referral services or service alternatives.</li>
                    </ul>
                </p>
                <p className='w-750'>
                    Clients entering the outpatient program at HMTP must meet the criteria for the following:
                    <ul>
                        <li>A mental health and/or substance related disorder diagnosis based on the current diagnostic and statistical manual (DSM-5 TR) for clients admitted to levels I-IV</li>
                        <li>The degree of severity based on six dimensions: intoxication and withdrawal; biomedical conditions and complications; emotional/behavioral/cognitive conditions and complications; treatment acceptance/resistance; relapse potential; and recovery environment. </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Urinalysis Service</u></b>
                </p>
                <p className='w-750'>
                    Urinalysis (urine toxicology screening) provides a valuable clinical tool to ensure client compliance to their prescribed treatment regimen. It is the policy of HMTTP to employ urine toxicology screening as an essential tool in the clinical treatment, monitoring, and management of all clients receiving alcohol and other drug services. Urinalysis shall be conducted by AEGGIS certified lab.
                </p>
                <p className='w-750'>
                    <b><u>Community Psychiatric Supportive Treatment (CPST) Service</u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide Community Psychiatric Supportive Treatment (CPST) by providing an array of services delivered by community based, mobile individuals or multidisciplinary teams of professionals and trained others. Services address the individualized mental health needs of the client. They are directed toward adults, children, adolescents, and families and will vary with respect to hours, type and intensity of services, depending on the changing needs of each individual.
                </p>
                <p className='w-750'>
                    The purpose/intent of CPST services is to provide specific, measurable, and individualized services to each person served. CPST services should be focused on the individual's ability to succeed in the community; to identify and access needed services; and to show improvement in school, work, family, and integration and contributions within the community
                </p>
                <p className='w-750'>
                    Activities of the CPST service shall consist of one or more of the following:
                    <ul>
                        <li>Ongoing assessment of needs</li>
                        <li>Assistance in achieving personal independence in managing basic needs as identified by the individual and/or parent or guardian.</li>
                        <li>Facilitation of further development of daily living skills, if identified by the individual and/or parent or guardian. </li>
                        <li>Coordination of the ITP, including:</li>
                        <ul>
                            <li>Services identified in the ITP</li>
                            <li>Assistance with accessing natural support systems in the community.</li>
                            <li>Linkage to formal community services/systems.</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>Symptom monitoring</li>
                        <li>Coordination and/or assistance in crisis management and stabilization as needed</li>
                        <li>Advocacy and outreach.</li>
                        <li>As appropriate to the care provided to individuals, and when appropriate to the family, education, and training specific to the individual's assessed needs, abilities, and readiness to learn.</li>
                        <li>Mental health interventions that address symptoms, behaviors, thought processes, etc., that assist an individual in eliminating barriers to seeking or maintaining education and employment.</li>
                        <li>Activities that increase the individual's capacity to positively impact his/her own environment.</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Therapeutic Behavioral Services (TBS) and Psychosocial Rehabilitation Services (PSR)</u></b>
                </p>
                <p className='w-750'>
                    HMTP will provide and deliver therapeutic behavioral services (TBS) and psychosocial rehabilitation services (PSR). TBS and PSR are an array of activities intended to provide individualized supports or care coordination of healthcare, behavioral healthcare, and non-healthcare services.
                </p>
                <p className='w-750'>
                    TBS and PSR may involve collateral contacts and may be delivered in all settings that meet the needsof the individual.
                </p>
                <p className='w-750'>
                    <b><u>TBS Service Activities</u></b>
                </p>
                <p className='w-750'>
                    TBS service activities include (but are not limited to) the following:
                    <ul>
                        <ul>
                            <li>Consultation with a licensed practitioner or an eligible provider pursuant to paragraph (C) of this rule (see, OAC 5122-29-18 (C) 'Eligible Providers'), to assist with the individual's needs and service planning for individualized supports or care coordination of healthcare, behavioral healthcare, and non-healthcare services to avoid more restrictive levels of treatments.</li>
                            <li>Referral and linkage to other healthcare, behavioral healthcare, and non-healthcare services to avoid more restrictive level of treatment</li>
                            <li>Interventions using evidence-based techniques.</li>
                            <li>Identification of strategies or treatment options</li>
                            <li>Restoration of social skills and daily functioning.</li>
                            <li>Crisis prevention and amelioration.</li>
                        </ul>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>PSR Service Activities</u></b>
                </p>
                <p className='w-750'>
                    PSR service activities include (but are not limited to) the following:
                    <ul>
                        <ul>
                            <li>Restoration, rehabilitation, and support of daily functioning to improve self-management of the negative effects of psychiatric or emotional symptoms that interfere with a person's daily functioning.</li>
                            <li>Restoration and implementation of daily functioning and daily routines critical to remaining successfully in home, school, work, and community. </li>
                            <li>Rehabilitation and support to restore skills to function in a natural community environment.</li>
                        </ul>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>TBS and PSR Eligible Providers</u></b>
                </p>
                <p className='w-750'>
                    <ul>
                        <ul>
                            <li>TBS- Those practitioners who have:</li>
                            <ul>
                                <li>A bachelor's or master's degree in social work, psychology, nursing, or in related human services, <b>OR</b></li>
                                <li>A high school diploma with a minimum of three years of relevant experience.</li>
                            </ul>
                            <li>PSR- Those practitioners who have </li>
                            <ul>
                                <li>A high school diploma, <b>AND</b> </li>
                                <li>Specific training related to persons with mental health conditions or needs.</li>
                            </ul>
                        </ul>
                    </ul>
                </p>
                <p className='w-750'>
                    <b><u>Telehealth/Interactive Video Conferencing</u></b>
                </p>
                <p className='w-750'>
                    {`HMTP will provide telehealth which OAC 5122-29-31 defines as “The use of, real-time audiovisual communications of such quality as to permit accurate and meaningful interaction between at least two persons, one of which is a certified provider of the service being provided pursuant to Chapter 5122- 25 of the Administrative Code. Asynchronous modalities that do not have both audio and video elements are considered telehealth.”`}
                </p>
                <p className='w-750'>
                    {`Telehealth services will be completed at the originating site and a distant site. HMTP will allow the client to make the decision of whether to provide initial or occasional in-person sessions. Telehealth shall be based upon client choice, appropriate clinical decision-making, and professional responsibility including the requirements of professional licensing, registration, or crediting boards.`}
                </p>
                <p className='w-750'>
                    The following services that may be provided via telehealth:
                    <ol>
                        <li>General services as defined in rule 5122-29-03 of the Administrative Code.</li>
                        <li>CPST service as defined in rule 5122-29-17 oof the Administrative Code</li>
                        <li>TBS and PSR services as defined in rule 5122-29-18 of the Administrative Code.</li>
                        <li>SUD case management service as defined in 5122-29-13 of the Administrative Code.</li>
                        <li>Crisis intervention services as defined in section 5122-29-10 of the Administrative Code.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b><u>Crisis Intervention Services</u></b>
                </p>
                <p className='w-750'>
                    HMTP will deliver crisis intervention to clients as needed. Crisis intervention services involve a face-toface response to a crisis or emergency experienced by a client, family member, and/or significant other. Crisis intervention services will be provided at HMTP or in the client's natural environment. The goal of crisis intervention services is to provide or assist the person(s) in obtaining those services necessary to stabilize the crisis situation.
                </p>
                <p className='w-750'>
                    Crisis Intervention includes:
                    <ul>
                        <li>An urgent evaluation of the following elements when clinically indicated:</li>
                        <ul>
                            <li>Understanding what happened to initiate the crisis and the individual's response or responses to it</li>
                            <li>Risk assessment of lethality, propensity of violence, and medical/physical condition including alcohol or drug use.</li>
                            <li>Mental status.</li>
                            <li>Information about the individual's strengths, coping skills, and social support network, including face-to-face contact with family and collateral informants.</li>
                            <li>Identification of treatment needs and appropriate setting of care.</li>
                        </ul>
                        <li>A crisis plan shall be developed to de-escalate the crisis, stabilize the patient, restore safety, provide referral and linkages to appropriate services, and coordination with other systems.</li>
                        <li>Individuals who have unstable medical problems shall be referred to a medical facility.</li>
                        <li>Individuals who have unstable psychiatric problems shall be referred to a psychiatric facility.</li>
                        <li>Individuals who are experiencing withdrawal symptoms from use of alcohol and/or other drugs shall be referred to a person and/or entity that can provide the appropriate level of detoxification services.</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <center><b>If you are experiencing a crisis, contact 419-914-CARE</b></center>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent or Legal Guardian: </td>
                        <td className='small w-250'> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature/Title:  </td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Here's My Turning Point </h3>
                </p>
                <p className='w-750'>
                    <h3>Intra-Agency Referral Form</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Staff Name Making Referral:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Referral:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtStaffNameMakingReferral' name='txtStaffNameMakingReferral' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateOfReferral' name='txtDateOfReferral' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h4>CLIENT DEMOGRAPHIC INFORMATION </h4>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbClientDemographicInformation_NewClientIntake' name='rbClientDemographicInformation' className='add-only' value='NewClientIntake' /> New Client (Intake)
                        </td>
                        <td className='150'>
                            Or
                        </td>
                        <td className='w-150'>
                            &nbsp; <input type='radio' id='rbClientDemographicInformation_ExistingClient' name='rbClientDemographicInformation' className='add-only' value='ExistingClient' /> Existing Client:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Client's Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medical Record#</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientstName' name='txtClientstName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicalRecord' name='txtMedicalRecord' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Parent and/or Legal Guardian (if a minor) Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtParentAndOrLegalGuardianMinorName' name='txtParentAndOrLegalGuardianMinorName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address, City State (incl. zip code)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddressCityStateZipCode' name='txtAddressCityStateZipCode' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address, City State (incl. zip code) Parent and/or Legal Guardian (if a minor) if address is different:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddressCityStateZipCodeParentLegalGuardianAddressDifferent' name='txtAddressCityStateZipCodeParentLegalGuardianAddressDifferent' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Home Phone #</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Cell Phone #</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DOB</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Sex</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Race</span> </td>
                        <td className='w-400'> <span className='eleHeader'>Marital Status:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDobO' name='txtDobO' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSexOne' name='txtSexOne' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtRace' name='txtRace' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single &nbsp;
                            <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married &nbsp;
                            <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced &nbsp;
                            <input type='radio' id='rbMaritalStatus_Widowed' name='rbMaritalStatus' className='add-only' value='Widowed' /> Widowed
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Potential Transportation Issues?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbPotentialTransportationIssues_No' name='rbPotentialTransportationIssues' className='add-only' value='No' /> No
                        </td>
                        <td className='150'>
                            Or
                        </td>
                        <td className='w-150'>
                            &nbsp; <input type='radio' id='rbPotentialTransportationIssues_Yes' name='rbPotentialTransportationIssues' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>If YES Explain</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtExplainIfYes' name='txtExplainIfYes' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>List current services client is enrolled in:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtListCurrentServiceClient' name='txtListCurrentServiceClient' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Current/Existing case manager or therapist Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCurrentExistingCaseManagerOrTherapistName' name='txtCurrentExistingCaseManagerOrTherapistName' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>CLINICAL INFORMATION Reason for Referral</span>
                    <textarea id='txtCLINICALINFORMATIONReasonForReferral' name='txtCLINICALINFORMATIONReasonForReferral' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>MH Diagnosis</span> </td>
                        <td className='w-375'> <span className='eleHeader'>SUD Diagnosis</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMHDiagnosis' name='txtMHDiagnosis' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSUDDiagnosis' name='txtSUDDiagnosis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ASAM Level of Care (SUD diagnosis)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtASAMLevelOfCareSUDDiagnosis' name='txtASAMLevelOfCareSUDDiagnosis' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Referral Services Requested' (check all that apply):</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Nature of services needed by client:{`***ITP must be attached***`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_1' name='cbNatureOfServicesNeededByClient_1' className='add-only' value='Assessment' /> Assessment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_2' name='cbNatureOfServicesNeededByClient_2' className='add-only' value='AddictionTxLevelIOP' /> Addiction Tx Level/IOP
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_3' name='cbNatureOfServicesNeededByClient_3' className='add-only' value='SUDCaseManagement' /> SUD /Case-management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_4' name='cbNatureOfServicesNeededByClient_4' className='add-only' value='GroupCounseling' /> Group Counseling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_5' name='cbNatureOfServicesNeededByClient_5' className='add-only' value='Urinalysis' /> Urinalysis
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_6' name='cbNatureOfServicesNeededByClient_6' className='add-only' value='DayTreatment' /> Day Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_7' name='cbNatureOfServicesNeededByClient_7' className='add-only' value='IndividualCounseling' /> Individual Counseling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_8' name='cbNatureOfServicesNeededByClient_8' className='add-only' value='FamilyCounseling' /> Family Counseling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_9' name='cbNatureOfServicesNeededByClient_9' className='add-only' value='Medical' /> Medical
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_10' name='cbNatureOfServicesNeededByClient_10' className='add-only' value='SUDCaseManagement' /> SUD Case Management
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_11' name='cbNatureOfServicesNeededByClient_11' className='add-only' value='TBSPSR' /> TBS/PSR
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNatureOfServicesNeededByClient_12' name='cbNatureOfServicesNeededByClient_12' className='add-only' value='CPST' /> CPST
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>New Case Manager Assigned:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature/Licensure/Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>New Therapist Assigned:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature/Licensure/Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Clinical Director:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature/Licensure/Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3> <u>Multiple Relationships</u> </h3>
                </p>
                <p className='w-750'> 
                {`Ohio Administrative Code Rule 4758-2-01 defines Multiple Relationship as: `}
                </p>
                <p className='w-750'>
                 {` Any financial, social, emotional, supervisory, political, administrative, legal or sexual relationship between a license or certificate holder and their client/consumer which might impair the professional judgment or increase the risk of client/consumer exploitation.`}
                </p>
                <p className='w-750'>
                    {`Ohio Administrative Code Rule 4757-5-03:`}
                </p>
                <p className='w-750'>
                    {`Examples of multiple relationships include but are not limited to the following: Familial relationships, Social relationships, Emotional relationships, Financial relationships, Supervisory relationships, Political relationships, Administrative relationships, Legal relationships, and/or Social media/personal virtual relationships, including online communities. `}
                </p>
                <p className='w-750'>
                    I acknowledge that potential multiple relationships and/or conflicts of interest have been discussed with me and I have disclosed the following:
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAcknowledgePotentialMultiple' name='cbAcknowledgePotentialMultiple' className='add-only' value='None' /> None
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Name of Staff </td>
                        <td className='small w-375'> Relationship </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Name of Staff </td>
                        <td className='small w-375'> Relationship </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Name of Staff </td>
                        <td className='small w-375'> Relationship </td>
                    </tr>
                </table>
                <p className='w-750'> 
                    {`The listed Multiple Relationship is not harmful to me, and it is in my best interest to continue services at Here's My Turning Point, LLC. I understand that I will not be supervised in any way by the staff member listed above. Issues such as informed consent, consultation, and supervision have been discussed and considered to ensure that judgment is not impaired, and that no exploitation occurs. Should any multiple relationship and/or conflict arise in the future, I will immediately notify staff.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Intake Staff Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

























































            </div>
        </form>

    )
} 